import ApolloClient from 'apollo-boost'
import fetch from 'isomorphic-fetch'

export const client = new ApolloClient({
  uri: 'https://mub0ovo1.api.sanity.io/v1/graphql/production/default',
  fetch,
})
